const mutations = {
    setService(state, data) {
        state.service = data;
    },
    setServiceList(state, data) {
        state.serviceList = data;
    },
    resetService(state) {
        state.service = {
            label: ''
        }

    }
}
export default mutations;